import { createAsyncThunk } from '@reduxjs/toolkit';
import { actionTypes } from './actionTypes';
import UserService from './service';

export const getUserAsync = createAsyncThunk(
  actionTypes.GET_USER,
  async (token) => {
    return UserService.getUser(token);
  }
);

export const loginAsync = createAsyncThunk(actionTypes.LOGIN, async () => {
  return UserService.login();
});

export const logoutAsync = createAsyncThunk(
  actionTypes.LOGOUT,
  async (token) => {
    return UserService.logout(token);
  }
);

export const editProfileAsync = createAsyncThunk(
  actionTypes.EDIT_PROFILE,
  async ({ formData, token }) => {
    return UserService.editProfile(formData, token);
  }
);
